import { BusinessAccountsInputFindSearchService } from '../../../../../../../core/services/search/business-accounts-input-find-search.service';
import { IBusinessAccountMappedItem } from '../../../../../../../logic/business-accounts/interfaces/i.business-account.mapped';
import { Directive, AfterViewInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusinessAccountLogicService } from '../../../../../../../logic/business-accounts/business-account.logic.service';
import { InputFindType } from '../../../input-find-type.enum';
import { BaseInputFindDialogDirective } from '../../base-input-find-dialog.component';

interface IData {
    mappedItem: IBusinessAccountMappedItem;
    searchService: BusinessAccountsInputFindSearchService;
    extraSearchParams: { [key: string]: any };
    dialogHeading: string;
    contentHeading: string;
    placeholder: string;
}

@Directive()
export class BusinessAccountsInputFindDialogDirective extends BaseInputFindDialogDirective<BusinessAccountLogicService> implements AfterViewInit {
    constructor(
        public readonly dialogRef: MatDialogRef<BusinessAccountsInputFindDialogDirective>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        public logicService: BusinessAccountLogicService,
        public cdRef: ChangeDetectorRef
    ) {
        super(
            dialogRef,
            data,
            logicService,
            cdRef,
            InputFindType.BusinessAccount,
        );
    }

    public ngAfterViewInit(): void {
        this.data.searchService.infiniteScrollContainer = this.scrollContainer;
        this.data.searchService.extraSearchParams = this.data.extraSearchParams;
        this.data.searchService.logicService = this.logicService;
        if (this.data.searchService.isPagination) {
            this.data.searchService.nextPage$.next({ addPage: 1 });
        } else {
            this.data.searchService.doSearchIfNoScrollBar();
        }
        this.cdRef.detectChanges();
    }
}
